import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NavigationContext = createContext(undefined);

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(location?.pathname);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [navigationHistory, setNavigationHistory] = useState([]);

  useEffect(() => {
    setActiveItem(location?.pathname);
    setNavigationHistory(prev => [...prev, location?.pathname]?.slice(-10));
  }, [location?.pathname]);

  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleAuthentication = (status) => {
    setIsAuthenticated(status);
    localStorage.setItem('isAuthenticated', status?.toString());
  };

  const value = {
    activeItem,
    isAuthenticated,
    navigationHistory,
    handleNavigate,
    handleAuthentication,
  };

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};